import { useRecordContext } from 'react-admin';
import { Alert, Chip, Stack, Typography } from '@mui/material';
import { SectionCard } from '../../shared/Panel';
import { vatSuggestionOf } from './vatSuggestion';

// Odczyt pola wspólny z kolumną VAT na liście (omówienie 01.10.2026).
export type { VatSuggestion } from './vatSuggestion';

/**
 * Podpowiedź VAT (W9) z macierzy klienta (25.09.2026), doprecyzowanej
 * odpowiedziami Marathonu/Euvic 16.10.2026 (pyt. 25: tylko sprzedaż).
 *
 * To podpowiedź, nie ustawienie: stawkę zatwierdza operator w TMS. Gdy
 * macierz nie rozstrzyga wprost albo brakuje danych, mówimy to wprost —
 * pusta stawka jest lepsza od zgadniętej.
 */
export const VatSection = () => {
  const vat = vatSuggestionOf(useRecordContext());
  if (!vat) return null;
  return (
    <SectionCard title="Rekomendowana stawka VAT">
      <Stack spacing={1}>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flexWrap: 'wrap' }}>
          <Chip
            size="small"
            color={vat.rate === null ? 'default' : vat.certain ? 'success' : 'warning'}
            label={vat.rate ?? 'brak rekomendacji'}
          />
          <Typography variant="body2">{vat.reason}</Typography>
        </Stack>
        {vat.missing.length > 0 && (
          <Typography variant="body2" color="text.secondary">
            Brakuje: {vat.missing.join(', ')}
          </Typography>
        )}
        {vat.rate !== null && !vat.certain && (
          <Alert severity="warning">
            Ta rekomendacja nie jest pewna — powód podano wyżej. Sprawdź stawkę, zanim wpiszesz ją
            w TMS.
          </Alert>
        )}
        <Typography variant="caption" color="text.secondary">
          Stawka dotyczy sprzedaży (faktury dla klienta), wynika z macierzy VAT i jest tylko
          rekomendacją — zatwierdzasz ją i wpisujesz w TMS. System jej nie zapisuje.
        </Typography>
      </Stack>
    </SectionCard>
  );
};
